import { normalizeEnglishWord } from '@/lib/wordValidation'

/** Limits and validation for English phrase input when adding manually. */
export const phraseInputLimits = {
  minLength: 3,
  maxLength: 200,
} as const

/** Multi-word English phrase: words separated by spaces; letters with optional hyphen or apostrophe. */
export const englishPhrasePattern =
  /^[A-Za-z]+(?:[-'][A-Za-z]+)*(?:\s+[A-Za-z]+(?:[-'][A-Za-z]+)*)+$/

export function normalizeEnglishPhrase(value: string): string {
  return normalizeEnglishWord(value).replace(/\s+/g, ' ')
}

/**
 * Live input sanitizer — strips invalid chars but keeps a trailing space
 * so the user can type multi-word phrases. Full trim happens on submit via
 * {@link normalizeEnglishPhrase}.
 */
export function sanitizeVocabularyInput(value: string): string {
  return value
    .replace(/[\u2018\u2019\u02BC`]/g, "'")
    .replace(/[\u2010-\u2014]/g, '-')
    .replace(/[^A-Za-z'`\-\s]/g, '')
    .replace(/ {2,}/g, ' ')
    .replace(/^\s+/, '')
    .slice(0, phraseInputLimits.maxLength)
}

export function isPhraseInput(value: string): boolean {
  return normalizeEnglishPhrase(value).includes(' ')
}

export function isValidEnglishPhrase(value: string): boolean {
  const normalized = normalizeEnglishPhrase(value)
  return (
    normalized.includes(' ') &&
    normalized.length >= phraseInputLimits.minLength &&
    normalized.length <= phraseInputLimits.maxLength &&
    englishPhrasePattern.test(normalized)
  )
}
